(function () {
  var PACK = 70000, FREE = 100000;
  function rand(c) {
    var n = Math.ceil(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R' + n;
  }

  /* product page extras, rendered by snippets/zg-pdp.liquid */
  var tpl = document.getElementById('zg-pdp');
  if (tpl && !document.querySelector('[data-zg-progress]')) {
    var pf = document.querySelector('.product__info-container product-form') || document.querySelector('product-form');
    if (pf) {
      var blk = pf;
      while (blk.parentElement && !blk.parentElement.classList.contains('product__info-container') && blk.parentElement !== document.body) blk = blk.parentElement;
      var frag = tpl.content.cloneNode(true);
      var nodes = [].slice.call(frag.children);
      var after = blk.nextSibling;
      nodes.forEach(function (n) {
        if (n.hasAttribute('data-zg-sticky')) document.body.appendChild(n);
        else if (n.hasAttribute('data-zg-progress')) blk.parentNode.insertBefore(n, blk);
        else blk.parentNode.insertBefore(n, after);
      });
    }
  }

  /* ingredient clash rules (shop metafield) */
  var D = null;
  var dataEl = document.getElementById('ic-data');
  if (dataEl) { try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; } }
  function clashes(items) {
    if (!D || !D.rules) return [];
    var P = D.products || {}, u = [], out = [];
    items.forEach(function (i) { if (!u.some(function (x) { return x.product_id === i.product_id; })) u.push(i); });
    D.rules.forEach(function (r) {
      for (var x = 0; x < u.length; x++) for (var y = x + 1; y < u.length; y++) {
        var A = P[String(u[x].product_id)] || [], B = P[String(u[y].product_id)] || [];
        if ((A.indexOf(r[0]) > -1 && B.indexOf(r[1]) > -1) || (A.indexOf(r[1]) > -1 && B.indexOf(r[0]) > -1)) out.push({ a: u[x].product_title, b: u[y].product_title, m: r[2] });
      }
    });
    return out;
  }

  function progressHTML(total) {
    var msg;
    if (total >= FREE) msg = '<strong>You\'ve unlocked free shipping and signature packaging</strong>';
    else if (total >= PACK) msg = 'Signature packaging unlocked. Add <strong>' + rand(FREE - total) + '</strong> more for <strong>free shipping</strong>';
    else if (total > 0) msg = 'Add <strong>' + rand(PACK - total) + '</strong> for signature packaging, or <strong>' + rand(FREE - total) + '</strong> for <strong>free shipping</strong>';
    else msg = '<strong>Free shipping</strong> on orders over R1,000, and <strong>signature packaging</strong> over R700';
    var w = Math.min(100, Math.round(total / FREE * 100));
    return '<div>' + msg + '</div><div class="zg-progress__bar"><i style="width:' + w + '%"></i></div><div class="zg-progress__marks"><span>R700 signature packaging</span><span>R1,000 free shipping</span></div>';
  }

  function ensure(parent, before, cls) {
    var el = parent.querySelector(':scope > .' + cls);
    if (!el) { el = document.createElement('div'); el.className = cls; parent.insertBefore(el, before); }
    return el;
  }

  function render(cart) {
    var total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var found = clashes(cart.items || []);
    var spots = [];
    document.querySelectorAll('.cart__ctas').forEach(function (c) { spots.push([c.parentNode, c]); });
    var note = document.querySelector('.cart-notification__links');
    if (note) spots.push([note, note.firstElementChild]);
    spots.forEach(function (s) {
      var p = ensure(s[0], s[1], 'zg-progress');
      p.setAttribute('role', 'status');
      p.innerHTML = cart.item_count ? progressHTML(total) : '';
      p.style.display = cart.item_count ? '' : 'none';
      var box = s[0].querySelector(':scope > .zg-clash');
      if (!found.length) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('div'); box.className = 'zg-clash zg-warn'; box.style.marginBottom = '1.2rem'; s[0].insertBefore(box, s[1]); }
      box.textContent = '';
      found.forEach(function (c) {
        var q = document.createElement('p'); q.style.margin = '0 0 0.8rem';
        var b = document.createElement('strong'); b.textContent = 'Heads up: ';
        q.appendChild(b); q.appendChild(document.createTextNode(c.a + ' and ' + c.b + '. ' + c.m));
        box.appendChild(q);
      });
      var n = document.createElement('p'); n.style.cssText = 'margin:0;font-size:1.2rem;opacity:.8';
      n.textContent = 'You can still check out. General guidance, not medical advice. Patch test new products.';
      box.appendChild(n);
    });
    document.querySelectorAll('[data-zg-progress]').forEach(function (el) { el.innerHTML = progressHTML(total); });
  }

  var t, busy = false;
  function check() {
    clearTimeout(t);
    t = setTimeout(function () {
      busy = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); })
        .catch(function () {})
        .then(function () { setTimeout(function () { busy = false; }, 50); });
    }, 250);
  }
  new MutationObserver(function (list) {
    if (busy) return;
    var hit = list.some(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentNode;
      if (!el || !el.closest || el.closest('.zg-progress, .zg-clash, [data-zg-progress]')) return false;
      return !!el.closest('cart-drawer, #CartDrawer, #main-cart-items, #main-cart-footer, cart-items, #cart-notification, #cart-icon-bubble');
    });
    if (hit) check();
  }).observe(document.body, { childList: true, subtree: true });
  check();

  /* sticky add to cart on product pages */
  var bar = document.querySelector('[data-zg-sticky]');
  var main = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
  if (bar && main && 'IntersectionObserver' in window) {
    var sb = bar.querySelector('[data-zg-sticky-btn]');
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var show = function (on) { bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); if (sb) sb.tabIndex = on ? 0 : -1; };
    show(false);
    new IntersectionObserver(function (e) { var r = e[0]; show(!r.isIntersecting && r.boundingClientRect.top < 0); }).observe(main);
    if (sb) sb.addEventListener('click', function () { if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } main.click(); });
  }
})();
